import ManualBillingDocumentPaymentMethod from '@/generated/controls/manualBillingDocument/ManualBillingDocumentPaymentMethod.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentPaymentMethod
})
